import { Platform } from "react-native";
import * as Device from 'expo-device';
import IosNoSuppotFaceId from '../mocks/IosNoSuppotFaceId.json'

export const getMajorVersionIOS = (): number => {
    if (Platform.OS != 'ios' ) {
      return null
    }
    return parseInt(Platform.Version, 10);
  }

  export const getMinorVersionIOS = (): number => {
    if (Platform.OS != 'ios' ) {
      return null
    }
  
    return parseInt(
      Platform.Version.substring(
        Platform.Version.indexOf('.') + 1
      )
    , 10);
  }

  export const getFaceIdSuportIos = () =>{
    return !IosNoSuppotFaceId.includes(Device.modelId)
  }